import React from 'react';
import { motion } from 'framer-motion';
import { UserCircle, Palette, Sparkles, Layers } from 'lucide-react';
const features = [{
  title: 'Custom Characters',
  description: 'Upload your photos to create consistent characters that appear throughout your story.',
  icon: UserCircle,
  color: 'bg-[#FFD700]'
}, {
  title: 'Multiple Styles',
  description: 'Choose from Comic, Manga, Manhwa, or Cartoon art styles to match your vibe.',
  icon: Palette,
  color: 'bg-[#ff4d4d]'
}, {
  title: 'AI Story Generation',
  description: 'Write a prompt or tap "Inspire" and get a full comic generated in minutes.',
  icon: Sparkles,
  color: 'bg-[#4dff4d]'
}, {
  title: 'Build Series',
  description: 'Create ongoing series with multiple episodes and consistent characters over time.',
  icon: Layers,
  color: 'bg-[#b366ff]'
}];
export function Features() {
  return <section id="features" className="py-24 bg-white relative overflow-hidden" data-id="element-31">
      {/* Decorative jagged top border */}
      <div className="absolute top-0 left-0 w-full h-4 bg-black" style={{
      clipPath: 'polygon(0 0, 100% 0, 100% 100%, 98% 0, 96% 100%, 94% 0, 92% 100%, 90% 0, 88% 100%, 86% 0, 84% 100%, 82% 0, 80% 100%, 78% 0, 76% 100%, 74% 0, 72% 100%, 70% 0, 68% 100%, 66% 0, 64% 100%, 62% 0, 60% 100%, 58% 0, 56% 100%, 54% 0, 52% 100%, 50% 0, 48% 100%, 46% 0, 44% 100%, 42% 0, 40% 100%, 38% 0, 36% 100%, 34% 0, 32% 100%, 30% 0, 28% 100%, 26% 0, 24% 100%, 22% 0, 20% 100%, 18% 0, 16% 100%, 14% 0, 12% 100%, 10% 0, 8% 100%, 6% 0, 4% 100%, 2% 0, 0 100%)'
    }} data-id="element-32"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bangers text-5xl md:text-6xl text-white text-stroke-black italic inline-block relative" data-id="element-35">
            Everything You Need to Create
            <div className="absolute -bottom-4 left-0 w-full h-2 bg-[#FFD700] comic-border -z-10" data-id="element-36"></div>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-37">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white comic-border comic-shadow p-6 flex flex-col items-center text-center hover:-translate-y-2 transition-transform duration-300" data-id="element-38">
              <div className={`w-20 h-20 ${feature.color} comic-border rounded-full flex items-center justify-center mb-6 comic-shadow-sm rotate-3`} data-id="element-39">
                <feature.icon size={40} className="text-black" strokeWidth={2.5} data-id="element-40" />
              </div>
              <h3 className="font-bangers text-3xl mb-3 tracking-wide" data-id="element-41">
                {feature.title}
              </h3>
              <p className="font-inter font-medium text-gray-800 leading-relaxed" data-id="element-42">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}